import { NavLink } from "react-router-dom";
import { Home, ShoppingCart, User, MessageCircle } from "lucide-react";
import { useCart } from "../context/CartContext";
import { useMessaging } from "../context/MessagingContext";

export default function BottomNav() {
  const { cartCount } = useCart();
  const { unreadTotal } = useMessaging();

  const linkBase = "flex flex-col items-center justify-center gap-1 text-[9px] font-semibold uppercase tracking-[0.22em]";
  const active = "text-neutral-900 dark:text-neutral-50";
  const inactive = "text-neutral-400 dark:text-neutral-500";

  return (
    <nav className="fixed inset-x-0 bottom-0 z-40 border-t border-neutral-200 bg-white/95 pb-[env(safe-area-inset-bottom)] backdrop-blur dark:border-neutral-800 dark:bg-neutral-900/95 md:hidden">
      <div className="grid h-14 grid-cols-4">
        <NavLink
          to="/"
          className={({ isActive }) => `${linkBase} ${isActive ? active : inactive}`}
          aria-label="Home"
        >
          <Home size={16} />
          Home
        </NavLink>
        <NavLink to="/cart" className={({ isActive }) => `${linkBase} ${isActive ? active : inactive}`}
          aria-label="Cart">
          <div className="relative">
            <ShoppingCart size={16} />
            {cartCount > 0 && (
              <span className="absolute -top-1.5 -right-2 rounded-full bg-rose-500 text-white text-[8px] px-1">
                {cartCount > 99 ? "99+" : cartCount}
              </span>
            )}
          </div>
          Cart
        </NavLink>
        <NavLink to="/messages" className={({ isActive }) => `${linkBase} ${isActive ? active : inactive}`}
          aria-label="Messages">
          <div className="relative">
            <MessageCircle size={16} />
            {unreadTotal > 0 && (
              <span className="absolute -top-1.5 -right-2 rounded-full bg-rose-500 px-1 text-[8px] text-white">
                {unreadTotal > 99 ? "99+" : unreadTotal}
              </span>
            )}
          </div>
          Chat
        </NavLink>
        <NavLink to="/account" className={({ isActive }) => `${linkBase} ${isActive ? active : inactive}`}
          aria-label="Account">
          <User size={16} />
          Account
        </NavLink>
      </div>
    </nav>
  );
}
